import React from 'react';
import { useIntl } from 'react-intl';
import IframeContent from '~/modules/common/components/IframeContent';
import { useMeContext } from '~/modules/me';
import { usePageTitle } from '~/modules/common/title';
import { useHideFooter } from '~/modules/common/hooks';
import { ScheduleManagementIcon } from '~/modules/common/components/Icons';
import { isMobileApp } from '~/util';

const VIEW_SHIFT_ASSIGNMENTS_ACTION =
  'urn:replicon:shift-assignment-action:view-shift-assignments';
const SCHEDULE_MANAGER_ACCESS_LEVEL =
  'urn:replicon:shift-assignment-data-access-level:schedule-manager';
const SUPERVISOR_ACCESS_LEVEL =
  'urn:replicon:shift-assignment-data-access-level:supervisor';
const PROJECT_MANAGER_ACCESS_LEVEL =
  'urn:replicon:shift-assignment-data-access-level:project-manager';

const ScheduleManagementPage = () => {
  const intl = useIntl();
  const { uiRootPath } = useMeContext();

  usePageTitle([{ messageId: 'routes.scheduleManagement' }]);
  useHideFooter();

  return (
    <IframeContent
      src={`${uiRootPath}embedded/schedulemanagement`}
      title={intl.formatMessage({ id: 'routes.scheduleManagement' })}
    />
  );
};

const scheduleManagementRoute = ({ me, intl }) => {
  const {
    featureFlags: { isTaProjectManagerShiftSchedulingEnabled },
    permissions
  } = me;

  const mobileAppValue = isMobileApp();
  const isNotMobileApp = mobileAppValue !== true && mobileAppValue !== 'true';

  const hasAccessLevel = accessLevelUri =>
    permissions.some(
      p =>
        p.permissionActionUri === VIEW_SHIFT_ASSIGNMENTS_ACTION &&
        p.dataAccessLevelUris.includes(accessLevelUri)
    ) && isNotMobileApp;

  const hasScheduleManagerOrSupervisorAccess =
    hasAccessLevel(SCHEDULE_MANAGER_ACCESS_LEVEL) ||
    hasAccessLevel(SUPERVISOR_ACCESS_LEVEL);

  const hasProjectManagerAccess = hasAccessLevel(PROJECT_MANAGER_ACCESS_LEVEL);

  return {
    path: '/schedulemanagement',
    icon: ScheduleManagementIcon,
    isSideBarRoute: true,
    component: ScheduleManagementPage,
    hidden: !me.featureFlags.isPsaPrpEmbedSchedulesInPolarisEnabled,
    title: () => intl.formatMessage({ id: 'routes.scheduleManagement' }),
    showDivider: true,
    hasPermission: Boolean(
      isTaProjectManagerShiftSchedulingEnabled
        ? hasScheduleManagerOrSupervisorAccess || hasProjectManagerAccess
        : hasScheduleManagerOrSupervisorAccess
    ),
    exact: false
  };
};

export default scheduleManagementRoute;
